module.exports = __webpack_public_path__ + "static/media/vintage-women-1-min.c82e291d.jpg";